export class Category {
  id = 0;
  name = '';
  inspection_Interval: number;
  expired = false;

  is_edit = false;
}
